
// ----------------------------------------------------------------------

export const THEME_SETTINGS = {
    themeMode: 'light', // 'light' | 'dark'
    themeDirection: 'ltr', //  'rtl' | 'ltr'
    themeContrast: 'default', // 'default' | 'bold'
    themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
    themeColorPresets: 'blue', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
    themeStretch: false,
    themeBorderRadius: 8, // 8 | 16 | 24 (New configurable param)
    themeBgColor: '#FFFFFF',
    themeTextColor: '#000000',
    themeCardColor: '#FFFFFF',
};
